export const isUploadInProgressSelector = state => state.upload.inProgress;



// WEBPACK FOOTER //
// ./src/selectors/uploadSelectors.js